import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { push } from "connected-react-router";
import { reduxForm, Field } from "redux-form";
import {
	Modal,
	Button,
	ReduxControls,
	Layout,
	ErrorBanner
} from "rhombus-react";

import { shareLibrary } from "reducers/LibraryProperties";
import { SHARE_LIBRARY } from "forms/list";
import InfoBanner from "./InfoBanner";

import "./ShareLibraryModal.css";

export function ShareLibraryModal(props) {
	let dispatch = useDispatch()
		, [error, setError] = useState(null)
		, [isSharing, setSharing] = useState(false)
		, { name = '', libraryId, returnPath, handleSubmit } = props
		, bladeProps = {
			verticallyCenter: true,
		}
		;

	function closeModal() {
		dispatch(push(returnPath));
	}

	const handleFormSubmit = handleSubmit((values) => {
		setSharing(true);
		return dispatch(shareLibrary(libraryId, [values.email]))
			.then((resp) => {
				setSharing(false);
				if(resp.success){
					closeModal();
					return resp;
				}
				const { errorObj } = resp.payload;
				setError(errorObj);
			});
	});

	function renderContent() {
		const hasErrors = !!error?.description;

		return (
			<div className="modal-body">
				{!hasErrors && (
					<InfoBanner>
						<strong>Please Note: </strong>This library will be shared with all users at the business associated with the email address.
					</InfoBanner>
				)}
				{hasErrors && (<ErrorBanner messages={[error.description]} title={error?.name} />)}
				<form id={SHARE_LIBRARY} onSubmit={handleFormSubmit}>
					<Field
						name      = "email"
						label     = "Enter the email address you wish to share this library with:"
						required  = {true}
						component = {ReduxControls.Input} />
				</form>
			</div>
		);
	}

	function renderFooter() {
		let saveProps = {
			form:      SHARE_LIBRARY,
			type:      "submit",
			isLoading: isSharing,
			theme:     "blue",
			icon:      isSharing ? "spinner" : null,
			disabled:  isSharing,
		};

		return (
			<Layout.ModalFooter>
				<Button
					theme="default"
					onClick={closeModal}>Cancel</Button>
				<Button {...saveProps}>Share Library</Button>
			</Layout.ModalFooter>
		);
	}

	return (
		<Modal
			title={`Share Library: ${name}`}
			type="modal"
			className="share-library-modal"
			bladeProps={bladeProps}
			xClose={true}
			allowFullScreen={false}
			renderContent={renderContent}
			renderFooter={renderFooter}
			onClose={closeModal}
		/>
	);
}

ShareLibraryModal.displayName = "ShareLibraryModal";

export default reduxForm({
	form: SHARE_LIBRARY,
	enableReinitialize: true,
})(ShareLibraryModal);

